import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronCircleRight = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M17.719 16L14.219 20.376C14.082 20.547 13.999 20.764 13.999 21C13.999 21.552 14.447 22 14.999 22C15.315 22 15.596 21.853 15.779 21.624L19.78 16.623C19.917 16.452 19.999 16.235 19.999 15.999C19.999 15.763 19.917 15.546 19.78 15.375L15.78 10.374C15.597 10.145 15.316 9.99805 15 9.99805C14.448 9.99805 14 10.446 14 10.998C14 11.234 14.082 11.451 14.22 11.622L17.72 15.998L17.719 16Z" />
	</svg>
);

export default ChevronCircleRight;
